import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Ana M.',
    location: 'Texas',
    text: "Nunca pensé que podría comer tacos y bajar de peso. Mi esposo ni siquiera se dio cuenta que era comida 'de dieta'. ¡Es increíble!",
    stars: 5,
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
  }, {
    name: 'Sofia R.',
    location: 'Florida',
    text: 'Llego del trabajo muerta y esto me salvó la vida. Literalmente en 7 minutos tengo la cena. Ya bajé 8 libras en un mes.',
    stars: 5,
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
  }, {
    name: 'Carmen L.',
    location: 'California',
    text: "Por fin una guía que entiende nuestra comida. Nada de ensaladas aburridas. El arroz con pollo 'fit' es mi favorito.",
    stars: 5,
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
  }];
  return <section className="py-20 bg-white" data-id="element-197">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-198">
        <div className="text-center mb-16" data-id="element-199">
          <h2 className="font-heading text-4xl font-bold text-[#2C1810] mb-4" data-id="element-200">
            Lo que dicen las latinas en USA
          </h2>
          <p className="text-xl text-gray-600" data-id="element-201">
            Ellas ya recuperaron su tiempo y su figura.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-202">
          {testimonials.map((t, i) => <div key={i} className="bg-[#FDF6EC] p-8 rounded-2xl shadow-sm hover:shadow-md transition duration-300" data-id="element-203">
              <div className="flex items-center gap-1 mb-4" data-id="element-204">
                {[...Array(t.stars)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#F5A623] text-[#F5A623]" data-id="element-205" />)}
              </div>
              <p className="font-body text-gray-700 mb-6 italic" data-id="element-206">"{t.text}"</p>
              <div className="flex items-center gap-4" data-id="element-207">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#F5A623]" data-id="element-208" />
                <div data-id="element-209">
                  <p className="font-bold text-[#2C1810]" data-id="element-210">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-211">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}